export const config = {
    soluciones: [
        {
            id: 1,
            value: 'codificacion',
            title: 'Soluciones en Codificación',
            color: '#7fbf20',
            icon: './assets/home/logo-codificacion.svg'
        },
        {
            id: 2,
            value: 'inspeccion',
            title: 'Soluciones en Inspección',
            color: '#4f9fc2',
            icon: './assets/home/logo-inspeccion.svg'
        },
        {
            id: 3,
            value: 'captura-automatica-datos',
            title: 'Identificación y Captura Automática de Datos',
            color: '#68a1f7',
            icon: './assets/home/logo-captura-datos.png'
        },
        {
            id: 4,
            value: 'procesamiento-inteligente-documentos',
            title: 'Procesamiento Inteligente de Documentos',
            color: '#6c757d',
            icon: './assets/home/logo-pid.svg'
        },
        {
            id: 5,
            value: 'suministros',
            title: 'Impresoras y suministros',
            color: '#f7120d',
            icon: './assets/home/logo-insumos.svg'
        },
        {
            id: 6,
            value: 'software',
            title: 'Software e Integración de Sistemas',
            color: '#40a653',
            icon: './assets/home/logo-software.svg'
        }
    ]
};